import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Button, CancelButton } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog, DialogProps } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Typography } from 'shared/mui/Typography';

type Props = DialogProps & {
  onReset: () => void;
};

export const OrderAdjustmentsResetDialog = ({ open, onClose, onReset }: Props) => {
  const translate = useTypedTranslate();

  return (
    <Dialog maxWidth="sm" onClose={onClose} open={open}>
      <CardHeader
        appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
        title={translate('app.orderAdjustments.resetDialog.title')}
        titleSize="smallBold"
      />
      <CardContent>
        <Typography>{translate('app.orderAdjustments.resetDialog.message')}</Typography>
      </CardContent>
      <CardActionsButtons
        rightActionsSlot={[
          <CancelButton
            key="cancel-button"
            label={translate('app.orderAdjustments.resetDialog.cancel')}
            onClick={onClose}
            variant="outlined"
          />,
          <Button
            key="save-button"
            label={translate('app.orderAdjustments.resetDialog.confirm')}
            onClick={onReset}
            variant="contained"
          />,
        ]}
      />
    </Dialog>
  );
};
